var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.775 19.8L0 14.025V5.775L5.775 0H14.025L19.8 5.775V14.025L14.025 19.8H5.775ZM6.765 14.575L9.9 11.44L13.035 14.575L14.575 13.035L11.44 9.9L14.575 6.765L13.035 5.225L9.9 8.36L6.765 5.225L5.225 6.765L8.36 9.9L5.225 13.035L6.765 14.575ZM6.71 17.6H13.09L17.6 13.09V6.71L13.09 2.2H6.71L2.2 6.71V13.09L6.71 17.6Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/cancelar.efae892b06f40ab3a8d827d66299d8c7.svg";
export { ForwardRef as ReactComponent };